import { observer } from 'mobx-react-lite'

import { useGlobalCopyStore, useInsightsV2Store } from '../../../common'

import type { Beat } from '../../../core'
import type { SaveExtraBlockData } from '../../../core/types/InsightsInstanceSlotData'

import { MakeTransferActionBlock } from './MakeTransferActionBlock'
import { resolveMakeTransferVariant } from './layout'

/**
 * Adapter that plugs MakeTransfer into the ActionBlock registry.
 *
 * The variants are content-only — ActionBlockLayer owns the surrounding Drawer
 * (open/close/title). This adapter derives the variant from the clicked CTA, the
 * copy from GlobalCopyStore, and passes the slot data through; each variant reads
 * the fields it needs.
 */
export const MakeTransferActionBlockLayer = observer(function MakeTransferActionBlockLayer({
  beat,
}: {
  beat: Beat
}) {
  const { actionDrawer } = useInsightsV2Store()
  const { insights_feed: insightsFeedCopy } = useGlobalCopyStore()

  const payload = beat.insights_payload
  const cta =
    actionDrawer.trigger === 'secondaryCta' ? payload?.secondary_cta : payload?.primary_cta

  return (
    <MakeTransferActionBlock
      copy={insightsFeedCopy.make_transfer}
      slotData={payload?.instance_slot_data as SaveExtraBlockData | undefined}
      variant={resolveMakeTransferVariant(cta?.variant)}
    />
  )
})
